import analyticRoutes from './pages/AnalyticsPage/routes';

const items_3459 = [
    {
        label: 'Автозаполнение шаблонов',
        path: '/autocomplete-templates-ai',
        subItems: [],
    },
    {
        label: 'Ключевые слова',
        subItems: [
            {
                label: 'По поисковому запросу',
                active: true,
                path: '/analysis-search-query/summary',
            },
            {
                label: 'По категории',
                active: true,
                path: '/analysis-by-category/queries',
            },
            {
                label: 'По продавцу',
                active: true,
                path: '/keywords/analysis-by-sellers/queries',
            },
            {
                label: 'По бренду',
                active: true,
                path: '/keywords/analysis-by-brand/queries',
            },
            {
                label: 'По SKU',
                active: true,
                path: '/keywords/analysis-by-SKU/position',
            },
            {
                label: 'Топ ключевых слов',
                active: true,
                path: '/top-keywords',
            },
        ],
    },
    {
        label: 'Календарь',
        subItems: [],
        path: '/calendar/day',
        notification: 20,
    },
    {
        label: 'Ticket',
        subItems: [],
        path: '/ticket',
    },
]

const items_4272 = [
    {
        label: 'По всем товарам',
        path: 'for-all-products/by_date_and_market_name',
        subItems: [],
    },
    {
        label: 'По новинкам',
        path: 'on-new-products/news_by_date_and_market_name',
        subItems: [],
    },
    {
        label: 'По апдейтам',
        path: 'by-updates/updates_by_date_and_market_name',
        subItems: [],
    },
    {
        label: 'По ссылкам',
        path: 'by-links',
        subItems: [],
    },
    {
        label: 'По ошибкам сбора',
        path: 'by_collection_errors',
        subItems: [],
    },
    {
        label: 'Логи запросов',
        path: 'request-logs/by_date_and_market_name',
        subItems: [],
    },
    {
        label: 'Отзывы и вопросы',
        path: '',
        subItems: [
            {
                label: 'Работа с отзывами и вопросами',
                active: true,
                path: `/work-with-review/feedbacks`,
            },
            {
                label: 'Аналитика по отзывам',
                active: true,
                path: `analitics-review-feedbacks/by-product`,
            },
            {
                label: 'Аналитика по вопросам',
                active: true,
                path: `analitics-review-questions/by-product`,
            },
            {
                label: 'Автоматизация ответов',
                active: true,
                path: `/automation-of-responses/answer_templates`,
                error: [4, 5]
            },
            {
                label: 'Автоматизация вопросов',
                active: true,
                path: `/automation-of-questions/answer_templates`,
            },
            {
                label: 'ИИ анализ товара, бренда, категории',
                active: true,
                path: 'AI_analysis/product',
            },
            {
                label: 'Аномалии',
                active: true,
                path: '/anomalies/by-product',
            },
            {
                label: 'Статистика',
                active: true,
                path: '/statistics/reviews',
            },
        ],
    },
    {
        label: 'Social network',
        path: '/social-network/network-groups',
        subItems: [],
    },
    {
        label: 'Задачи',
        path: '/tasks/',
        subItems: [],
        // id: 17
    },
    {
        label: 'CRM',
        subItems: [],
        path: '/crm',
        notification: 20,
        // id: 19
    },
    {
        label: 'Wiki',
        subItems: [],
        path: '/wiki/wiki-list/main',
        // id: 18
    },
    {
        label: 'Чат бот',
        path: '/chat-bot',
        subItems: [],
        // id: 20
    },
    {
        label: 'Файлы',
        path: '/file',
        subItems: [],
        id: 21
    },
]

const items_4349 = [
    {
        label: 'Конкуренты',
        subItems: [
            {
                section_name: 'Добавить конкурентов',
                // section_icon: marketplace_icon,
                section: [
                    {
                        label: 'Посмотреть конкурентов/by_product',
                        path: '/view-competitors',
                    },
                    {
                        label: 'Добавить конкурентов',
                        path: '/add-competitors/all',
                    }
                ],
            },
        ],
    },
    {
        label: 'Файлы',
        path: '/file',
        subItems: [],
        id: 21
    },
]

export const returnMenu = (selectedSpace) => {
    const sidebarItems = [
        {
            label: 'Аналитика',
            subItems: [
                {
                    label: 'Общие графики',
                    active: true,
                    path: `/${analyticRoutes.analytics}/date`,
                },
                {
                    label: 'Реклама',
                    active: true,
                    path: `/${analyticRoutes.advertising}/date`,
                },
                {
                    label: 'Заказы и продажи',
                    active: true,
                    path: `/${analyticRoutes.ordersAndSales}/orders_list`,
                },
                {
                    label: 'Возвраты и отмены',
                    active: true,
                    path: `/${analyticRoutes.returnAndCancellations}/list`,
                },
                {
                    label: 'Цены',
                    active: true,
                    path: `/${analyticRoutes.prices}/price_by_products`,
                },
                {
                    label: 'Остатки',
                    active: true,
                    path: `/${analyticRoutes.stock}/stock_by_days`,
                },
                {
                    label: 'АБС/XYZ анализ',
                    active: true,
                    path: `/${analyticRoutes.abc}/ABC_by_products`,
                },
                {
                    label: 'Low-high',
                    active: true,
                    path: `/${analyticRoutes.lowHigh}/LH_by_products`,
                },

                ...((selectedSpace?.value === 3867 || selectedSpace?.value === 3459)
                    ? [
                        {
                            label: 'Отчет по брендам',
                            active: true,
                            path: `/${analyticRoutes.brand_report}/date`,
                        },
                        {
                            label: 'Срезы',
                            active: true,
                            path: `/${analyticRoutes.slices}/date`,
                        },
                    ]
                    : []),
                {
                    label: 'Кросс Аналитика',
                    active: true,
                    path: '/cross-analytics/charts',
                },
                // {
                //   label: "Динамика рекламных показателей",
                //   active: true,
                //   path: "/dynamics_advertising_indicators",
                // },
                {
                    label: 'Подсказочник',
                    active: true,
                    path: '/hint',
                },
            ],
        },
        {
            label: 'Маржинальность',
            subItems: [
                {
                    label: 'Установка себестоимости',
                    path: '/setting-cost-price/parameters',
                },
                {
                    label: 'Анализ маржинальности',
                    active: true,
                    path: `/${analyticRoutes.marginality_analysis}/sebes_by_dates`,
                },
                {
                    label: 'Расчет маржинальности',
                    path: '/maintaining-marginality',
                },
            ],
        },
        {
            label: 'Товары',
            path: '',
            subItems: [
                {
                    section_name: 'Мастер товары',
                    // section_icon: star_icon,
                    section: [
                        {
                            label: 'Список товаров',
                            active: true,
                            path: '/products_list_master_product/all',
                        },
                        {
                            label: 'Добавить товар',
                            active: true,
                            path: '/add-product/required',
                        },
                        {
                            label: 'Установка цен',
                            active: true,
                            path: '/set-price-and-margin-master-product/price_setting',
                        },
                        {
                            label: 'Установка остатков',
                            active: true,
                            path: '/set-remaining-goods-master-product/setting-balances',
                        },
                        {
                            label: 'Перенос товаров',
                            active: true,
                            path: '/content-transfer/all',
                        },
                        {
                            label: 'Улучшение товара',
                            active: true,
                            path: '/mass-improvement/all',
                        },
                        // {
                        //   label: 'Рассчет поставки',
                        //   active: true,
                        //   path: '/calculation-delivery/calculation',
                        // },
                        {
                            label: 'Настройки',
                            path: '/setting-master-product',
                        },

                        // {
                        //   label: 'Проверка ОВХ',
                        //   path: '/checking-OVH/all',
                        // },
                        // {
                        //   label: 'Посмотреть конкурентов',
                        //   path: '/view-competitors/all',
                        // },
                        // {
                        //   label: 'Добавить конкурентов',
                        //   path: '/add-competitors/all',
                        // },
                    ],
                },
                {
                    section_name: 'Товары на площадках',
                    // section_icon: marketplace_icon,
                    section: [
                        {
                            label: 'Список товаров',
                            active: true,
                            path: '/products_list',
                        },
                        {
                            label: 'Конкуренты',
                            active: true,
                            path: '/competitors/add_competitors',
                        },
                        {
                            label: 'Установка цен',
                            active: true,
                            path: '/set-price-and-margin',
                        },
                        {
                            label: 'Установка остатков',
                            active: true,
                            path: '/set-remaining-goods',
                        },
                        {
                            label: 'Проверка ОВХ',
                            path: '/checking-OVH/all_table',
                        },
                        {
                            label: 'Рассчет поставки',
                            active: true,
                            path: '/calculation-delivery',
                        },
                    ],
                },
            ],
        },
        {
            label: 'Биддер',
            //path: 'not-active',
            subItems: [
                {
                    section_name: 'Рекламные кампании',
                    // section_icon: marketplace_icon,
                    section: [
                        {
                            label: 'Список рекламных кампаний',
                            path: '/marketing-place/list-of-advertising-campaigns/all',
                        },
                        {
                            label: 'Товары в кампании',
                            path: '/marketing-place/products-in-campaign/products_in_campaign_participate_items',
                        },
                        {
                            label: 'Cоздать кампанию из правил',
                            path: '/create-campaign-from-rules',
                        },
                        {
                            label: 'Аналитические подборки',
                            path: '/marketing-place/analytical-collections/low_turnover_rate',
                        },
                        {
                            label: 'Low-high анализ',
                            path: '/low-high_analysis/product',
                        },
                        {
                            label: 'Аналитика по метрикам',
                            path: 'analytics-by-metrics/total',
                        },
                        {
                            label: 'Рекомендации',
                            // path: 'recommendations',
                            path: '/not-active',
                        },
                        // {
                        //   label: 'Установка ДРР',
                        //   path: 'installation-DRR/all',
                        // },
                    ],
                },
                // Временно скрыт
                // {
                //   section_name: 'Внешняя реклама',
                //   section_icon: marketplace_icon,
                //   section: [
                //     {
                //       label: 'Аналитические подборки',
                //       path: '/out-marketing-place/analytical-collections/all_product',
                //       active: false,
                //     },
                //     {
                //       label: 'Список рекламных кампаний',
                //       path: '/out-marketing-place/list-of-advertising-campaigns/all',
                //       active: false,
                //     },
                //     {
                //       label: 'Товары в кампании',
                //       path: '/out-marketing-place/products-in-campaign/products_in_campaign_participate_items',
                //       active: false,
                //     },
                //     {
                //       label: 'Cоздать кампанию из правил',
                //       path: '/not-active',
                //       active: false,
                //     },
                //   ],
                // },
            ],
        },
        {
            label: 'Репрайсер',
            subItems: [
                {
                    label: 'Стратегии',
                    path: '/repricing/all',
                    error: [13]
                },
            ],
        },
        {
            label: 'Отзывы и вопросы',
            path: '',
            subItems: [
                {
                    label: 'Работа с отзывами и вопросами',
                    active: true,
                    path: `/work-with-review/feedbacks`,
                },
                {
                    label: 'Аналитика по отзывам',
                    active: true,
                    path: `analitics-review-feedbacks/by-product`,
                },
                {
                    label: 'Аналитика по вопросам',
                    active: true,
                    path: `analitics-review-questions/by-product`,
                },
                {
                    label: 'Автоматизация ответов',
                    active: true,
                    path: `/automation-of-responses/answer_templates`,
                    error: [4, 5]
                },
                {
                    label: 'Автоматизация вопросов',
                    active: true,
                    path: `/automation-of-questions/answer_templates`,
                },
                {
                    label: 'ИИ анализ товара, бренда, категории',
                    active: true,
                    path: 'AI_analysis/product',
                },
                {
                    label: 'Аномалии',
                    active: true,
                    path: '/anomalies/by-product',
                },
                {
                    label: 'Статистика',
                    active: true,
                    path: '/statistics/reviews',
                },
            ],
        },
        {
            label: 'Акции',
            path: '',
            subItems: [
                {
                    label: 'Товары в акции',
                    path: '/marketing-place/promotions/joined-promotions/all',
                },
                {
                    label: 'Список акций',
                    path: '/marketing-place/promotions/list-promotion/all',
                },
                {
                    label: 'Правила',
                    path: '/marketing-place/promotions/promotion-rules/all',
                },
                {
                    label: 'Стратегии',
                    path: '/strategy-promotion'
                },
            ],
        },
        {
            label: 'Конкуренты',
            subItems: [
                {
                    section_name: 'Добавить конкурентов',
                    // section_icon: marketplace_icon,
                    section: [
                        {
                            label: 'Посмотреть конкурентов',
                            path: '/view-competitors/by_product',
                        },
                        {
                            label: 'Добавить конкурентов',
                            path: '/add-competitors/all',
                        }
                    ],
                },
            ],
        },
        {
            label: 'Заказы',
            active: true,
            subItems: [
                {
                    label: 'Заказы',
                    active: true,
                    path: '/order-management',
                },
                {
                    label: 'Поставки',
                    active: true,
                    path: '/deliveries/awaiting_packaging',
                },
            ],
        },
        {
            label: 'Поставки',
            active: true,
            subItems: [
                {
                    label: 'Список поставок',
                    active: true,
                    path: '/supply-list/supply_list',
                },
            ],
        },
        {
            label: 'Возвраты',
            active: true,
            subItems: [
                {
                    label: 'Работа с возвратами',
                    active: true,
                    path: '/working-with-returns',
                },
                {
                    label: 'Список возвратов по статусам',
                    active: true,
                    // path: '/list-of-returns-by-status',
                    path: '/not-active',
                },
                {
                    label: 'Готовые к выдаче',
                    active: true,
                    // path: '/ready-for-pickup',
                    path: '/not-active',
                },
                {
                    label: 'Автоматизация возвратов',
                    active: true,
                    path: '/automation-returns',
                },
            ],
        },
        ...(selectedSpace?.value === 3459 ? [...items_3459] : []),
        {
            label: 'Social network',
            path: '/social-network/network-groups',
            subItems: [],
        },
        {
            label: 'Задачи',
            path: '/tasks/',
            subItems: [],
            // id: 17
        },
        {
            label: 'CRM',
            subItems: [],
            path: '/crm',
            notification: 20,
            // id: 19
        },
        {
            label: 'Wiki',
            subItems: [],
            path: '/wiki/wiki-list/main',
            // id: 18
        },
        {
            label: 'Чат бот',
            path: '/chat-bot',
            subItems: [],
            // id: 20
        },
        {
            label: 'Файлы',
            path: '/file',
            subItems: [],
            id: 21
        },
    ];

    if (selectedSpace?.value === 4272) {
        return items_4272
    }
    if (selectedSpace?.value === 4349) {
        return items_4349
    }
    return sidebarItems
}